import SimpleSchema from 'simpl-schema';

import store from '../../config/configureStore';
import { getCategoryOfCode } from 'utils/functions';

const validRelationshipsCounts = (subjectIds, victimIds) => {
  let totalRelationships = 0;

  subjectIds.map((sID) => {
    totalRelationships += victimIds.includes(sID) ? victimIds?.length - 1 : victimIds?.length;
  });

  return totalRelationships;
};

export const incSubjectVictimRelationshipSchema = () => {
  SimpleSchema.setDefaultMessages({
    messages: {
      en: store?.store.getState().incident.ibrsValidationRules?.incSubjectVictimRelationship || {},
    },
  });

  return new SimpleSchema({
    allRelations: {
      type: Array,
      optional: true,
      custom() {
        // NIBRS-2019.2-109: Victim Connected to Offense
        const ibrsVersion = store.store.getState().user?.ibrsVersion;

        let crimeAgainst = this.obj.offensesOffenseForm.values?.statuteDetails?.CrimeAgainst;
        const isLaSociety40C =
          ibrsVersion === 'LA' &&
          crimeAgainst === 'SOCIETY' &&
          this.obj.offensesOffenseForm.values?.statuteDetails?.FBICode === '40C';
        let missingRelations =
          !this.value.length ||
          this.value.length !== validRelationshipsCounts(this.obj.subjectIds, this.obj.victimIds) ||
          this.value.some((r) => !(r.Relationship ?? r.relationship));

        if (
          missingRelations &&
          (crimeAgainst === 'PERSON' ||
            (crimeAgainst === 'PROPERTY' && this.obj.victimType) ||
            /* Relationship is required for 40C which is crimeAgainst SOCIETY for LA */
            isLaSociety40C)
        ) {
          return 'NIBRS-2019.2-109';
        }
      },
    },
    'allRelations.$': {
      type: Object,
      optional: true,
      blackbox: true,
      custom() {},
    },
    victimOffenders: {
      type: Array,
      optional: true,
      custom() {
        if (this.value.length > 10) {
          return 'NIBRS-2019.2-148';
        }
      },
    },
    'victimOffenders.$': {
      type: SimpleSchema.Integer,
      optional: true,
      custom() {},
    },
    victimSpouses: {
      type: Array,
      optional: true,
      custom() {
        if (this.value.length > 1) {
          return 'NIBRS-2019.2-152';
        }
      },
    },
    'victimSpouses.$': {
      type: SimpleSchema.Integer,
      optional: true,
      custom() {},
    },
    relationship: {
      type: String,
      label: 'Relationship',
      optional: true,
      custom() {
        const ibrsVersion = store.store.getState().user?.ibrsVersion;
        const codeVictimSubjectRelationship = store.store.getState().dictionary
          .codeVictimSubjectRelationship;
        const victimRelationshipCategory = getCategoryOfCode(
          codeVictimSubjectRelationship,
          this.value
        );

        if (victimRelationshipCategory === 'se') {
          if (this.obj.victim.age < 13) return 'NIBRS-2019.2-127';
        }

        if (victimRelationshipCategory === 'pa' || victimRelationshipCategory === 'gp') {
          if (this.obj.victim.age < this.obj.subject.age) return 'NIBRS-2019.2-159';
        }

        if (victimRelationshipCategory === 'ch' || victimRelationshipCategory === 'gc') {
          if (this.obj.victim.age > this.obj.subject.age) return 'NIBRS-2019.2-160';
        }

        /* The Relationship tab is disabled for this case */
        // NIBRS-2019.2-149: Offender Number
        // const codeVictimCategory = store.store.getState().dictionary.codeVictimCategory;
        // if (!['i', 'l'].includes(getCategoryOfCode(codeVictimCategory, this.obj.victim.category))) {
        //   if (this.value) {
        //     return 'NIBRS-2019.2-149';
        //   }
        // }

        /* TODO: Need to adjust the validation based on the new relationship changes */
        //NIBRS-2019.2-150: Offender Number
        // if (
        //   this.obj.offense?.values?.statuteDetails?.CrimeAgainst === 'PERSON' ||
        //   (this.obj.offense?.values?.statuteDetails?.CrimeAgainst === 'PROPERTY' &&
        //     this.obj.victim?.category === 'I')
        // ) {
        //   if (this.value === undefined || this.value === null || this.value === '') {
        //     return 'NIBRS-2019.2-150';
        //   }
        // }

        //NIBRS-2019.2-154: Relationship to Victim
        const codeRace = store.store.getState().dictionary.codeRace;
        const codeSex = store.store.getState().dictionary.codeSex;
        if (
          this.obj.offenderDetails.age === 0 &&
          getCategoryOfCode(codeRace, this.obj.offenderDetails.race) === 'u' &&
          getCategoryOfCode(codeSex, this.obj.offenderDetails.sex) === 'u'
        ) {
          if (victimRelationshipCategory !== 'ru') {
            return 'NIBRS-2019.2-154';
          }
        }

        //NIBRS-2019.2-301
        if (victimRelationshipCategory === 'vo') {
          if (
            this.obj.offenseList?.some((value) =>
              ['11A', '11B', '11C', '11D', '370', '90C'].includes(value)
            )
          ) {
            return 'NIBRS-2019.2-301';
          }
        }

        //NIBRS-2019.2-302
        if (
          this.value &&
          !['pa', 'sp', 'sb', 'ch', 'sc', 'gp', 'gc', 'of'].includes(victimRelationshipCategory)
        ) {
          if (this.obj.offenseList.includes('36A')) {
            return 'NIBRS-2019.2-302';
          }
        }
        //'TEXAS-2023.1-08'
        if (ibrsVersion === 'TX') {
          if (
            ['ch', 'pa', 'gp', 'gc', 'sp', 'sc', 'cf'].includes(victimRelationshipCategory) &&
            Math.abs(this.obj.victim.age - this.obj.subject.age) < 11
          ) {
            return 'TEXAS-2023.1-08';
          }
        }
      },
    },
    offenderSex: {
      type: String,
      optional: true,
      custom() {},
    },
  });
};
